<template>
  <div>
    <v-container v-if="history">
      <v-row>
        <h2 class="pb-4 pt-2">Fahrzeugeinsatz</h2>
      </v-row>
      <v-row>
        <v-col cols="12">
          <div style="height: 400px">
            <LineChart :datasets="datasets" :labels="labels" :options="options"/>
          </div>
        </v-col>
      </v-row>
    </v-container>
    <LoadingIndicator v-else/>
  </div>
</template>

<script>
import has from 'lodash/has';
import uniq from 'lodash/uniq';
import { mapState } from 'vuex'
import LineChart from '@/components/LineChart.vue'
import LoadingIndicator from '@/components/LoadingIndicator.vue'
import SearchRangeMixin from '@/mixins/SearchRangeMixin'
import TitleMixin from '@/mixins/TitleMixin'
import { chartColor } from '@/utils/chartColors'

export default {
  name: 'VehicleUtilizationHistory',

  components: {
    LineChart,
    LoadingIndicator,
  },

  computed: mapState({
    searchRange: state => state.search.range,

    title: function() {
      return `Fahrzeugeinsatz - ${import.meta.env.VITE_NAME}`;
    },
  }),

  data: () => ({
    datasets: null,
    err: null,
    history: null,
    labels: null,
    options: {
      maintainAspectRatio: false,
      scales: {
        x: {
          stacked: true
        },
        y: {
          stacked: true
        }
      }
    },
    readableVehicleType: {
      ICE01: 'ICE 1 (BR 401)',
      ICE02: 'ICE 2 (BR 402)',
      ICE03: 'ICE 3 (BR 403)',
      ICE8: 'ICE 3neo (BR 408)',
      ICE90: 'ICE 4 (BR 412.0)',
      ICE92: 'ICE 4 (BR 412.2)',
      ICE94: 'ICE 4 (BR 412.4)',
      ICE46: 'ICE 3M (BR 406)',
      ICE47: 'Velaro D (BR 407)',
      ICE11: 'ICE T (BR 411)',
      ICE15: 'ICE T (BR 415)',
    },
  }),

  methods: {
    getDatasets: function(history, labels) {
      var vehicleTypes = Object.keys(this.readableVehicleType);
      var result = vehicleTypes.map((key, index) => {
        var vehicleTypeHistory = history[key];
        var values = [];

        labels.forEach(label => {
          if (has(vehicleTypeHistory, label)) {
            values.push(vehicleTypeHistory[label]);
          } else {
            values.push(0);
          }
        });

        var color = chartColor(index);
        return {
          label: this.readableVehicleType[key],
          data: values,
          pointRadius: 1,
          borderColor: color,
          backgroundColor: color,
          fill: true,
        };
      });

      this.$log.debug(result);
      return result;
    },

    getLabels: function(history) {
      var rawLabels = [];
      Object.keys(history).forEach(function(vehicleType) {
        rawLabels = rawLabels.concat(Object.keys(history[vehicleType]));
      });
      return uniq(rawLabels);
    },

    getVehicleUtilizationHistory: function() {
      this.datasets = null;
      this.err = null;
      this.history = null;
      this.labels = null;

      this.$log.info("Retrieving vehicle utilization history");

      this.$api
        .get(`/vehicle/utilization/history${this.searchRangeToQuery(this.searchRange)}`)
        .then(response => {
          this.history = response.data;
          this.labels = this.toHumanReadableLabels(this.getLabels(this.history));
          this.$log.debug(this.labels)
          this.datasets = this.getDatasets(this.history, this.labels);

          this.$log.info("Finished retrieving vehicle utilization history");
        })
        .catch(err => {
          this.err = err;
          this.$log.error(err);
        });
    },

    toHumanReadableLabels: function(labels) {
      return labels.map(function(label) {
        return label;
      });
    },
  },

  mixins: [SearchRangeMixin, TitleMixin],

  mounted: function () {
    this.getVehicleUtilizationHistory()
  },

  watch: {
    searchRange: function () {
      this.getVehicleUtilizationHistory()
    },
  },
};
</script>
